import { FC } from 'react';
import { IconProps } from '@base/icon/interface';
import { SVG } from '@base/icon/SVG';

export const IconUser: FC<IconProps> = props => (
    <SVG
        {...props}
        path="M512 170.666667a128 128 0 1 0 0 256 128 128 0 0 0 0-256zM298.666667 298.666667a213.333333 213.333333 0 1 1 426.666666 0A213.333333 213.333333 0 0 1 298.666667 298.666667z m-108.202667 361.130666A213.333333 213.333333 0 0 1 341.333333 597.333333h341.333334a213.333333 213.333333 0 0 1 213.333333 213.333334v85.333333a42.666667 42.666667 0 1 1-85.333333 0v-85.333333a128 128 0 0 0-128-128H341.333333a128 128 0 0 0-128 128v85.333333a42.666667 42.666667 0 1 1-85.333333 0v-85.333333a213.333333 213.333333 0 0 1 62.464-150.869334z"
    />
);